import React from "react";
import { cn } from "../lib/utils";

interface SectionHeaderProps {
  badge?: string;
  title: string;
  subtitle?: string;
  className?: string;
}

export function SectionHeader({ badge, title, subtitle, className }: SectionHeaderProps) {
  return (
    <div className={cn("text-center mb-12 sm:mb-16 px-4", className)}>
      {badge && (
        <div
          className="inline-flex items-center px-4 py-2 rounded-full border border-[#1A4035] mb-6"
          style={{ backgroundColor: "rgba(46,179,154,0.12)" }}
        >
          <span className="text-sm font-semibold text-[#2EB39A] uppercase tracking-wide">{badge}</span>
        </div>
      )}
      <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white leading-tight mb-4">{title}</h2>
      {subtitle && (
        <p className="text-base sm:text-lg text-[#9ABFB5] leading-relaxed max-w-2xl mx-auto">{subtitle}</p>
      )}
    </div>
  );
}
